import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { v4 as uuidv4 } from 'uuid'
import { Color, Colors } from '../styles/Colors';
import ToggleForm from './ToggleForm';
import GenericForm from './forms/GenericForm';
import DocActionMenu from './DocActionMenu';
import { useTranslation } from 'react-i18next';

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 6.25rem; 
    width: 100%; 
    min-height: 60px; 
    heigh: 100%; 
    border-bottom: 3px double ${Color(Colors.black)};
    padding: 1rem 0 1rem 0; 
    margin: 0; 

    &:first-of-type {
        border-top: 3px double ${Color(Colors.black)};
    }

    & > div:first-of-type { 
        padding: 0 0 0 .5rem; 

        & > p {
            width: 100%; 
            white-space: pre-wrap;
            overflow-wrap: anywhere; 
            word-break: break-word; 
        }

        & > p:first-of-type {
            font-weight: 600;
            padding: 0 0 1rem 0;  
        }

        & > p:last-of-type {
            white-space: pre-line; 
        }
    }

    & > div:last-of-type { 
        /* flex: 1; */
        padding: 0 .5rem 0 .5rem; 
        display: flex; 
        justify-content: flex-end; 
        align-items: flex-start;
    }
`;

const EditableItemList = ({ addItems, setAddItems, storageKey, emptyListMsg, addItemMsg, editItemMsg }) => {
    const { t } = useTranslation(); 
    const dynamicFields = [
        {
            type: 'text',
            label: t('common.formLabels.title.name'),
            name: 'title',
            placeholder: t('common.formLabels.title.label'),
            required: true,
        },
        {
            type: 'textarea',
            label: t('common.formLabels.description.name'),
            name: 'description',
            placeholder: t('common.formLabels.description.label'),
            required: true,
        },
    ]

    const [editItem, setEditItem] = useState({ id: null, task: '', title: '', description: '' });
    const [newTask, setNewTask] = useState({ id: null, title: '', description: '' });

    useEffect(() => {
        localStorage.setItem(storageKey, JSON.stringify(addItems));
    }, [addItems, storageKey]);

    const editItemSubmit = (event) => {
        event.preventDefault();
        const { title, description } = editItem;

        setAddItems((prevItem) =>
            prevItem?.map((item) =>
                item.id === editItem.id
                    ? {
                        ...item,
                        title: title,
                        description: description
                    }
                    : item
            )
        );

        setEditItem({ id: null, title: '', description: '' });
    };

    const handleEditCancel = () => {
        setEditItem(prev => ({
            ...prev, 
            id: null
        }))
    }; 

    const submitNewTask = (event) => {
        event.preventDefault();
        const { title, description } = newTask;

        setAddItems((prevItem) => [
            ...prevItem,
            {
                title: title,
                description: description,
                id: uuidv4(),
            },
        ]);

        setNewTask({ id: null, title: '', description: '' });
    };

    const handleDeleteText = (id) => {
        const deleteItems = addItems.filter((item) => item.id !== id)
        setAddItems(deleteItems);
        localStorage.setItem(storageKey, JSON.stringify(deleteItems))
    };

    const handleEditTextClick = (item) => {
        setEditItem({
            id: item.id,
            title: item.title,
            description: item.description
        });
    };

    const handleEditChange = (event) => {
        const { name, value } = event.target;
        setEditItem({ ...editItem, [name]: value });
    };

    const handleNewTaskChange = (event) => {
        const { name, value } = event.target;
        setNewTask({ ...newTask, [name]: value });
    };

    return (
        <div>
            {addItems && addItems.length > 0 ? (
                addItems.map((item, index) => 
                    editItem.id === item.id ? (
                            <GenericForm
                                key={item.id}
                                item={editItem}
                                setItem={setEditItem}
                                handleOnChange={handleEditChange}
                                handleEditCancel={handleEditCancel}
                                handleSubmit={editItemSubmit}
                                title={`${editItemMsg} #${index + 1}`}
                                buttonText={t('common.saveBtnLabel')}
                                dynamicFields={dynamicFields}
                                buttonColorTheme='lightBlue'
                                isEditing={editItem.id === item.id}
                            />
                        ) : (
                            <Wrapper key={index}>
                                <div>
                                    <p>{item.title}</p>
                                    <p>{item.description}</p>
                                </div>
                                <div>
                                    <DocActionMenu
                                        item={item}
                                        handleDeleteText={handleDeleteText}
                                        handleEditTextClick={handleEditTextClick}
                                    />
                                </div>
                            </Wrapper>
                        )
                )
            ) : (
                <span>{emptyListMsg}</span>
            )}
            <ToggleForm>
                <GenericForm
                    item={newTask}
                    setItem={setNewTask}
                    handleOnChange={handleNewTaskChange}
                    handleSubmit={submitNewTask}
                    title={addItemMsg}
                    buttonText={t('common.addBtnLabel')}
                    dynamicFields={dynamicFields}
                    buttonColorTheme='darkBlue'

                />
            </ToggleForm>
        </div>
    );
};

export default EditableItemList;